import styled from "styled-components";
import { variant, space } from "styled-system";

const HeaderNavigationItem = styled("li")(
  {
    listStyle: "none",
    textTransform: "uppercase",
    a: {
      fontWeight: props => props.theme.fontWeights.regular,
      padding: "5px 0",
      boxShadow: "inset 0px -2px 0px transparent",
      transition: "all 200ms ease-in-out",
    },
  },
  space,
  props =>
    variant({
      variants: {
        light: {
          a: {
            color: "header.light.link",
            boxShadow:
              props.active &&
              "inset 0px -2px 0px " + props.theme.colors.header.light.link,
            "&:hover": {
              boxShadow:
                "inset 0px -2px 0px " + props.theme.colors.header.light.link,
            },
          },
        },
        grey: {
          a: {
            color: "header.grey.link",
            boxShadow:
              props.active &&
              "inset 0px -2px 0px " + props.theme.colors.header.grey.link,
            "&:hover": {
              boxShadow:
                "inset 0px -2px 0px " + props.theme.colors.header.grey.link,
            },
          },
        },
        dark: {
          backgroundColor: "header.grey.dark",
          a: {
            color: "white.100",
            boxShadow:
              props.active &&
              "inset 0px -2px 0px " + props.theme.colors.white["100"],
            "&:hover": {
              boxShadow:
                "inset 0px -2px 0px " + props.theme.colors.white["100"],
            },
          },
        },
      },
    })
);

HeaderNavigationItem.defaultProps = {
  mx: ["10px", null, null, null, 3],
};

export { HeaderNavigationItem };
